import React from 'react';
import {withSystem, Plugins, Atom} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {extraAttrs} from '../utils';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {TText, TRecord} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const UserAccountFormSaveButton = Atom.createRender(
  ({attributes, classes, generateAttributes}) => {
    const buttonClasses = classes.push('w-button');

    return <input {...generateAttributes(attributes, buttonClasses)} />;
  }
);

const config = createIntegratedAtom({
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Button')),
  },
  constraints: {
    page: [{type: 'UtilityPage', is: ['usys-user-account']}],
  },
  showEmpty: false,
  displayName: 'Submit Button',
  render: UserAccountFormSaveButton,
  fields: {
    attr: withSystem(
      {private: false},
      TRecord(
        {
          value: withSystem({label: 'Text', isFullWidth: true}, TText),
          'data-wait': withSystem(
            {label: 'Waiting Text', isFullWidth: true},
            TText
          ),
        },
        extraAttrs
      )
    ),
  },
  style: {
    base: {
      main: {
        noPseudo: {
          textAlign: 'center',
          marginRight: px(8),
        },
      },
    },
  },
});

export default config;
